import type { ClientLibraryId } from 'types/client-library'
import type { Thunk } from 'types/redux'
import api from '@disco/api/server'
import {
  CLIENT_LIBRARY_STATS_LOAD,
  CLIENT_LIBRARY_STATS_LOAD_FAIL,
  CLIENT_LIBRARY_STATS_LOAD_SUCCESS,
} from '@disco/constants/ActionTypes'
/**
 * Loads statistics for a specific client library with custom parameters.
 * @param libraryId - ID of the client library to load stats for
 * @param params - Parameters for customizing the stats query
 * @returns Thunk that loads library statistics and handles success/error states
 */
export function clientLibraryStatsLoad(
  libraryId: ClientLibraryId,
  params: Record<string, any>,
): Thunk {
  return async dispatch => {
    dispatch({
      type: CLIENT_LIBRARY_STATS_LOAD,
      libraryId,
    })

    try {
      const response = await api.getClientLibraryStats(libraryId, params)
      dispatch({
        type: CLIENT_LIBRARY_STATS_LOAD_SUCCESS,
        libraryId,
        response,
      })
    } catch (error) {
      dispatch({
        type: CLIENT_LIBRARY_STATS_LOAD_FAIL,
        libraryId,
        error,
      })
    }
  }
}
